import { statsUtils } from ".";
import * as THREE from "three";
import { ThreeView } from "../webcad";

/* geoUtils
 * ユーティリティ関数クラス.
 */
export class geoUtils {

	// public static mergeMeshes(mesh1: THREE.Mesh, mesh2: THREE.Mesh): THREE.Mesh {
	// 	const geo2: THREE.BufferGeometry = <THREE.BufferGeometry>(mesh1.geometry);
	// 	const geo3: THREE.BufferGeometry = <THREE.BufferGeometry>(mesh2.geometry);
	// 	geo2.merge(geo3, 0); // index = 0 ok???
	// 	return mesh1;
	// }

	public static disposeGeometry(geometry: any) {
		if ((geometry == undefined) || (geometry.dispose == undefined)) return;
		geometry.dispose();
		geometry = undefined;
	}

	public static disposeMaterial(material: any) {
		if (material == undefined) return;
		if ((material.map != undefined) && (material.map.dispose != undefined)) {
			material.map.dispose();
		}
		if ((material.envMap != undefined) && (material.envMap.dispose != undefined)) {
			material.envMap.dispose();
		}
		if (material.dispose != undefined) {
			material.dispose();
			material = undefined;
		}
	}

	public static disposeObj(obj: any) {
		if ((obj == undefined) || (obj.dispose == undefined)) return;
		obj.dispose();
	}

	public static disposeObject(object: THREE.Object3D, dryrun?: boolean) {
		if (object == undefined) return;
		if ((dryrun != undefined) && dryrun) return;
		let mesh = <THREE.Mesh>(object);
		if (mesh.isMesh) {
			geoUtils.disposeGeometry(mesh.geometry);
			mesh.geometry = undefined;
			geoUtils.disposeMaterial(mesh.material);
			mesh.material = undefined;
			object.remove(mesh);
			geoUtils.disposeObj(mesh);
		}
		if (object.children != undefined) {
			for (let i = 0; i < object.children.length; i++) {
				this.disposeObject(object.children[i], dryrun);
			}
		}
		geoUtils.disposeObj(object);
	}
}
